<div class="ccm_usage">
    <div class="spinner-content" *ngIf="loading">
        <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div class="ccm_usage_left cgm_usage_left" *ngIf="!loading">
        <h4>CGM Usage</h4>
        <p [innerHTML]="dataInsight?.cgm_text | safeHtml"></p>
        <ul>
            <li>Participants using CGM Device</li>
            <li>Participants not using CGM device</li>
        </ul>
    </div>
    <div class="ccm_usage_ryt">
        <canvas id="cgmPieChart" height="180" width="180"></canvas>
    </div>

</div>